import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { ChevronDownIcon } from '@heroicons/react/24/outline';

import { useCurrentUser, useSignOut } from 'services/repositories/user/user';
import { getInitials } from 'support/helpers/generic/generic';
import { routeToPage } from 'support/helpers/navigation/navigation';
import { OrderFormsRoutes } from 'support/types';

import { HeaderMenuButton } from './HeaderMenuButton/HeaderMenuButton';

type MenuButtonItem = Parameters<typeof HeaderMenuButton>['0']['items'][0];
export const ProfileMenu = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { data: currentUser } = useCurrentUser();
  const { mutate: logout } = useSignOut();

  if (!currentUser) {
    return null;
  }

  const userName = currentUser.name;
  const initials = getInitials(userName);

  const menuItems: Array<MenuButtonItem> = [
    {
      value: t('auth:logout'),
      onClick: () =>
        logout(null, {
          onSuccess: () => {
            navigate(routeToPage(OrderFormsRoutes.login));
          },
        }),
    },
  ];

  const trigger = (
    <div className="flex items-center justify-between space-x-3">
      <div className="inline-flex size-10 items-center justify-center rounded-full bg-gray-200">
        <span className="text-sm font-medium leading-none text-gray-700">{initials}</span>
      </div>
      <ChevronDownIcon className="size-4" />
    </div>
  );

  return <HeaderMenuButton trigger={trigger} items={menuItems} menuAlignment="right" />;
};
